import React from 'react';
import styled from 'styled-components';

import { flexCenter } from '@ecp/common/src/style/theme/defaultStyled';
import { overrideProperties } from '@ecp/common/src/style/utils';
import { positionPropTypes, sizePropTypes } from '@ecp/common/src/style/propTypes';
import boTheme from '@ecp/common/src/style/theme/bo';
import BadgeUnstyled from '@ecp/common/src/components/unstyled/badge/BadgeUnstyled';
import { BadgePropTypes } from '@ecp/common/src/components/badge/Badge';

const DefaultBadge = styled.span.attrs(({ badgeContent, style }) => ({
  style: {
    ...style,
    padding: badgeContent > 10 ? '0 6px' : 0,
    borderRadius: badgeContent > 10 ? '30px' : '50px',
  },
}))`
  ${flexCenter};
  position: absolute;
  height: 18px;
  min-width: 18px;
  background: ${boTheme.color.error1};
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  color: ${boTheme.color.sub10};
  font-size: ${boTheme.font.size.sub};
  font-weight: ${boTheme.font.weight.bold};

  ${overrideProperties(positionPropTypes, {})};
  ${overrideProperties(sizePropTypes, {})};
`;

const DefaultBadgeRoot = styled.div`
  position: relative;
  width: fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
`;

const Badge = React.forwardRef(({ position, size, ...props }, ref) => {
  return <BadgeUnstyled {...props} badgeProps={{ ...position, ...size }} ref={ref} />;
});

Badge.propTypes = BadgePropTypes;

Badge.defaultProps = {
  rootComponent: DefaultBadgeRoot,
  badgeComponent: DefaultBadge,
};

Badge.displayName = 'Badge';

export default Badge;
